import React, { FC } from 'react';

import Image from 'common/Image';

import { SocialNetworksProps } from './models';

const SocialNetworks: FC<SocialNetworksProps> = ({ socialMediaLogo, className, sizeIcon }) => (
  <div className={className}>
    {socialMediaLogo &&
      socialMediaLogo.map(({ image, url }, index) => (
        <a
          key={url[0].url}
          href={url[0].url}
          target="_blank"
          rel="noreferrer"
          className={` container__icons `}
        >
          <Image
            imageData={image}
            alt=""
            data-testid="banner-image-desktop"
            className={`${sizeIcon} icon-${index}`}
          />
        </a>
      ))}
  </div>
);

export default SocialNetworks;
